// ASK attachments and answers on the website (Round 10).
// Files are uploaded through the proxy (/api/ask/upload) to MBTS GridFS, owned
// by the signed-in user; the next ASK request carries their ids (askFiles).
// Answers may come with sources (askSources) and files (askFiles: name, mime,
// size, signed link); the file opens through /api/ask/file/<link>.

export const ASK_ACCEPT = ".pdf,.docx,.xlsx,.xls,.csv,.txt,.md,.json,.png,.jpg,.jpeg,.gif,.webp";
export const ASK_MAX_BYTES = 20 * 1024 * 1024;
export const MAX_ATTACHMENTS = 5;

export async function uploadAskFile(file, userId) {
  if (!file) return { ok: false, message: "No file was chosen." };
  if (file.size > ASK_MAX_BYTES) return { ok: false, message: `That file is too big. The limit is ${ASK_MAX_BYTES / (1024 * 1024)} MB.` };
  const form = new FormData();
  form.append("userId", userId || "");
  form.append("file", file, file.name);
  try {
    const res = await fetch("/api/ask/upload", { method: "POST", body: form });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.file) return { ok: false, message: data.message || "That upload didn't work. Please try again." };
    return { ok: true, file: { id: data.file.id, name: data.file.name, kind: data.file.kind, size: data.file.size } };
  } catch (_) {
    return { ok: false, message: "That upload didn't work. Please try again." };
  }
}

// The answer text without the "Sources:" list and the "📎 file" line (both are
// shown as links and cards instead, and should not be read aloud).
export function cleanAskText(text) {
  return String(text || "")
    .replace(/\n\n📎 [^\n]*/u, "")
    .replace(/\n\nSources:\n(?:\d+\. [^\n]*(?:\n|$))+/u, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

export const askFileUrl = (link) => `/api/ask/file/${encodeURIComponent(link)}`;

export function fileSizeLabel(n) {
  const b = Number(n) || 0;
  if (b >= 1024 * 1024) return `${(b / (1024 * 1024)).toFixed(1)} MB`;
  if (b >= 1024) return `${Math.round(b / 1024)} KB`;
  return `${b} B`;
}
